import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { HiOutlineMail, HiCake } from 'react-icons/hi';
import { GiMolecule, GiChemicalTank } from 'react-icons/gi';
import { GrGraphQl } from 'react-icons/gr';
import { TbNetwork } from 'react-icons/tb';
import { toast } from 'react-toastify';
import TextareaAutosize from 'react-textarea-autosize';
import { Spinner } from 'flowbite-react';

import { Section, Label } from 'components/Section';
import request from 'utils/https-request';

function Profile() {
  const [isRequestInProgress, setIsRequestInProgress] = useState(false);
  const { register, handleSubmit, reset } = useForm();

  const onSubmit = async data => {
    setIsRequestInProgress(true);
    toast('아직 미구현된 기능입니다 ㅇ ㅅㅇa');
    setIsRequestInProgress(false);
  };
  return (
    <>
      <Section className="bg-white">
        <div className="grid grid-cols-2 gap-x-4 gap-y-10 sm:gap-y-20">
          <div className="col-span-2 lg:order-last lg:col-span-1">
            <div className="relative mx-auto w-full bg-slate-100 xs:h-96 xs:w-96">
              <img className="h-full w-full" src="/Images/MeowSeo_01.png" alt="" />
              <div className="absolute left-8 top-8 -z-10 hidden h-full w-full bg-teal-300 sm:block" />
            </div>
          </div>

          <div className="col-span-2 mx-auto flex max-w-xl flex-col justify-center px-4 lg:col-span-1 lg:max-w-none">
            <div className="flex flex-wrap items-end gap-y-2">
              <h3 className="mr-4 text-5xl font-bold">Welcome to</h3>
              <h3 className="font-logo text-4xl text-teal-500">NEWSEO.ME!</h3>
            </div>
            <h3 className="text-5xl font-bold">Great to see you.</h3>
            <p className="mt-6 text-2xl">
              I'm glad to have you here on my private website. This website serves as a space to
              introduce me and various projects and works that I have developed.
            </p>
          </div>
        </div>
      </Section>

      <Section className="bg-gray-50">
        <div className="grid grid-cols-2 gap-x-4 gap-y-10 sm:gap-y-20">
          <div className="col-span-2 lg:col-span-1">
            <div className="relative mx-auto w-full xs:h-96 xs:w-96">
              <img
                className="relative z-10 h-full w-full rounded-full bg-white"
                src="/Images/MeowSeo_02.png"
                alt=""
              />
              <div className="absolute -left-6 top-6 hidden h-full w-full rounded-full bg-gray-300 sm:block" />
            </div>
          </div>

          <div className="col-span-2 mx-auto flex max-w-xl flex-col justify-center px-4 lg:col-span-1 lg:max-w-none">
            <div className="flex flex-wrap items-end justify-center gap-y-2">
              <h3 className="mr-4 text-4xl font-bold xs:text-5xl">SunYoo Hwang</h3>
              <h3 className="mr-4 text-4xl font-bold xs:text-5xl">(황선유)</h3>
            </div>
            <div className="mx-auto">
              <div className="mt-6 flex items-center">
                <div className="w-14  min-w-[3.5rem]">
                  <HiCake className="text-3xl" />
                </div>
                <div className="text-2xl">1995 . 05 . 08</div>
              </div>
              <div className="mt-2 flex items-start">
                <div className="w-14 min-w-[3.5rem] text-2xl font-semibold">B.S.</div>
                <div className="break-words text-2xl">
                  Chemical and Biological Engineering, Korea University (2020)
                </div>
              </div>
              <div className="mt-2 flex items-start">
                <div className="w-14 min-w-[3.5rem] text-2xl font-semibold">M.S.</div>
                <div className="text-2xl">
                  Chemical and Biological Engineering, Korea University (2022)
                </div>
              </div>
              <div className="mt-2 flex items-center">
                <div className="w-14  min-w-[3.5rem]">
                  <HiOutlineMail className="text-3xl" />
                </div>
                <div className="text-2xl">neros12@naver.com</div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section className="bg-white">
        <Label eng_label="Research Area" kor_label="연구 분야" />
        <div className="mx-auto grid max-w-lg grid-cols-1 gap-20 md:max-w-none md:grid-cols-2">
          <div className="w-full space-y-4 px-4">
            <GiMolecule className="mx-auto h-24 w-24 text-sky-500" />
            <h5 className="text-center text-3xl font-semibold">Molecular representation</h5>
            <p className="text-left text-xl font-medium text-gray-700">
              Molecular representation is a method used to express the structure and properties of a
              moleculethe in a mathematical and computationally understandable form.
            </p>
          </div>
          <div className="w-full space-y-4 px-4">
            <GiChemicalTank className="mx-auto h-24 w-24 text-orange-500" />
            <h5 className="text-center text-3xl font-semibold">Chemcial process design</h5>
            <p className="text-left text-xl font-medium text-gray-700">
              Chemical processes are crucial in the production of chemical products. They are
              designed by considering factors such as reaction conditions, and optimal controls of
              operation.
            </p>
          </div>
          <div className="w-full space-y-4 px-4">
            <GrGraphQl className="mx-auto h-24 w-24 text-slate-500" />
            <h5 className="text-center text-3xl font-semibold">
              AI based chemical property estimation
            </h5>
            <p className="text-left text-xl font-medium text-gray-700">
              Chemical properties are essential for chemcial process but most of them are not
              reported. With neural-network technology, more accurate properties can be calculated.
            </p>
          </div>
          <div className="w-full space-y-4 px-4">
            <TbNetwork className="mx-auto h-24 w-24 text-teal-500" />
            <h5 className="text-center text-3xl font-semibold">Web Programming</h5>
            <p className="text-left text-xl font-medium text-gray-700">
              We share information and interact with users over the internet. Web programming is a
              essential tool for accessing information and utilizing services in now days.
            </p>
          </div>
        </div>
      </Section>

      <Section className="bg-gray-50">
        <Label eng_label="Publications" kor_label="논문" />
        <div className="grid grid-cols-1 gap-16 px-10 md:grid-cols-2">
          <a href="https://link.springer.com/article/10.1007/s10765-022-03060-7" target="_blank">
            <div className="relative mx-auto h-[32rem] max-w-xl overflow-y-hidden rounded-lg border border-gray-200 p-4 text-lg shadow-xl hover:scale-105">
              <div className="text-2xl font-semibold">
                Group Contribution-Based Graph Convolution Network: Pure Property Estimation Model.
              </div>
              <div className="my-2 text-sm text-[#004b83]">S. Y. Hwang, J. W. Kang</div>
              <div className="mb-1 border-b border-gray-400 pb-1 text-sm font-semibold">
                Abstract
              </div>
              <div className="text-sm">
                Properties data for chemical compounds are essential information for the design and
                operation of chemical processes. Experimental values are reported in the literature,
                but that are too scarce compared with exploding demand for data. When the data are
                not available, various estimation methods are employed. The group contribution
                method is one of the standards and simple techniques used today. However, these
                methods have inherent inaccuracy due to the simplified representation of the
                molecular structure. More advanced methods are emerging, including improved
                molecular representations and handling experimental data. However, such processes
                also suffer from a lack of valid data for adjusting many parameters. We suggest a
                compromise between a complex machine learning algorithm and a linear group
                contribution method in this contribution. Instead of representing a molecule using a
                graph of atoms, we employed bulkier blocks—a graph of functional groups. The new
                approach dramatically reduced the number of adjustable parameters for machine
                learning. The result shows higher accuracy than the conventional methods. The whole
                process was also examined in various aspects—incorporating uncertainties in the
                data, the robustness of the fitting process, and detecting outlier data.
              </div>
              <div className="absolute -bottom-1 left-0 w-full ">
                <div className="h-4 bg-gradient-to-t from-white/100 to-white/0" />
                <div className="h-4 bg-white" />
              </div>
            </div>
          </a>
          <a href="https://link.springer.com/article/10.1007/s10765-022-03141-7" target="_blank">
            <div className="relative mx-auto h-[32rem] max-w-xl overflow-y-hidden rounded-lg border border-gray-200 p-4 text-lg shadow-xl hover:scale-105">
              <div className="text-2xl font-semibold">
                Group contribution based graph convolution network: predicting vapor–liquid
                equilibrium with cosmo-sac-ml
              </div>
              <div className="my-2 text-sm text-[#004b83]">
                B. C. Ryu, S. Y. Hwang, S. S. Kang, D. Yang, J. W. Kang
              </div>
              <div className="mb-1 border-b border-gray-400 pb-1 text-sm font-semibold">
                Abstract
              </div>
              <div className="text-sm">
                The conductor-like screening model with the segment activity coefficient (COSMO-SAC)
                model enables us to predict the liquid phase behavior based on quantum chemical
                calculations when experimental information is unavailable. However, the quantum
                chemical COSMO calculations require significant computational resources (software,
                hardware, experience, and time) for successful results. In this work, we suggest
                machine learning models for replacing COSMO calculations to alleviate the
                computational burden. The machine learning (ML) models include graph convolutional
                neural networks. The ML models were constructed based on the molecular level
                structural information and previous COSMO calculation databases. Additional COSMO
                calculations were generated to train several missing functional groups, which are
                not included in the existing databases. The ML prediction abilities were shown by
                comparison of generated cavity volume and sigma profile with the original COSMO-SAC.
                The vapor–liquid equilibrium (VLE) prediction results were also compared with the
                original COSMO-SAC and the UNIQUAC functional-group activity coefficients (UNIFAC)
                model. It is shown that the suggested ML models can predict VLE with reasonable
                <div className="h-4 bg-white" />
                <div className="absolute -bottom-1 left-0 w-full ">
                  <div className="h-4 bg-gradient-to-t from-white/100 to-white/0" />
                  <div className="h-4 bg-white" />
                </div>
              </div>
            </div>
          </a>
          <a href="https://link.springer.com/article/10.1007/s10765-025-03632-3" target="_blank">
            <div className="relative mx-auto h-[32rem] max-w-xl overflow-y-hidden rounded-lg border border-gray-200 p-4 text-lg shadow-xl hover:scale-105">
              <div className="text-2xl font-semibold">
                Korea Thermophysical Properties Databank (KDB): Web Service for Critically Evaluated
                Thermophysical Data and Prediction Methods
              </div>
              <div className="my-2 text-sm text-[#004b83]">
                S. Y. Hwang, B. C. Ryu, S. S. Kang, H. Bang, J. W. Kang
              </div>
              <div className="mb-1 border-b border-gray-400 pb-1 text-sm font-semibold">
                Abstract
              </div>
              <div className="text-sm">
                Thermophysical properties data are crucial for education, research, process
                modeling, and operational activities in chemical engineering. Supported by the
                Korean government, Korea University has been providing this data continuously since
                1997 (www.cheric.org). Recently, a new version of the Korean Thermophysical
                Properties Data Bank (KDB) (www.mdlkdb.com) has been developed and released. This
                updated version features an expanded database and enhanced calculation capabilities.
                It includes critically evaluated data for 1970 compounds and offers 5567 binary
                vapor–liquid equilibrium (VLE) data sets. The standard references are assessed based
                on criteria such as uncertainty, reproducibility, predictability, and consistency,
                ensuring the reliability and quality of the data. Additionally, machine learning
                methods for property estimation have been developed using the NIST/TRC database, and
                these calculation modules have been integrated into the new web interface. The
                property calculation page allows users to perform calculations for pure properties
                and binary vapor–liquid equilibrium using methods such as UNIFAC, COSMO-SAC, and a
                machine learning version of COSMO-SAC for certain simpler cases. This contribution
                outlines the functionalities and evaluation procedures of the KDB, which is an
                ongoing project aimed at enhancing the accessibility and reliability of
                thermophysical data while also improving precision in chemical process modeling and
                design.
                <div className="h-4 bg-white" />
              </div>
              <div className="absolute -bottom-1 left-0 w-full ">
                <div className="h-4 bg-gradient-to-t from-white/100 to-white/0" />
                <div className="h-4 bg-white" />
              </div>
            </div>
          </a>
        </div>
      </Section>

      {/* <Section>
        <Label eng_label="Previous Projects" />
        <div className="grid grid-cols-1 gap-x-10 gap-y-16 px-4 sm:grid-cols-2">
          <div>
            <div>물성예측모듈 GC-gcn 개발</div>
            <div>인화점 향상제 탐색</div>
          </div>
          <div>
            <div>ChemicAI.org</div>
            <div>www.newseo.me</div>
            <div>www.kdcm.or.kr</div>
            <div>www.doxmeet.com</div>
          </div>
        </div>
      </Section> */}

      <Section className="bg-white">
        <Label eng_label="Available Tools" />
        <div className="grid grid-cols-1 gap-x-10 gap-y-16 px-4 sm:grid-cols-2 lg:grid-cols-3">
          <div className="mx-auto h-52 max-w-sm items-center space-y-3">
            <img className="mx-auto h-14 w-14" src="/Images/Profile-Icons/matlab.png" alt="" />
            <div className="text-center text-3xl font-semibold text-teal-700">Matlab</div>
            {/* <div className="text-lg text-gray-600">
              MATLAB is a programming and numeric computing platform to analyze data, develop
              algorithms, and create models.
            </div> */}
          </div>
          <div className="mx-auto h-52 max-w-sm items-center space-y-3">
            <img className="mx-auto h-14 w-14" src="/Images/Profile-Icons/python.png" alt="" />
            <div className="text-center text-3xl font-semibold text-teal-700">Python</div>
            {/* <div className="text-lg text-gray-600">
              Python is a high-level, general-purpose programming language. It emphasizes code
              readability with the use of indentation via the off-side rule.
            </div> */}
          </div>
          <div className="mx-auto h-52 max-w-sm items-center space-y-3">
            <img className="mx-auto h-14 w-14" src="/Images/Profile-Icons/javascript.png" alt="" />
            <div className="text-center text-3xl font-semibold text-teal-700">JavaScript</div>
            {/* <div className="text-lg text-gray-600">
              JavaScript is a programming language that is one of the core technologies of the World
              Wide Web, alongside HTML and CSS.
            </div> */}
          </div>
          <div className="mx-auto h-52 max-w-sm items-center space-y-3">
            <img className="mx-auto h-14 w-14" src="/Images/Profile-Icons/tensorflow.png" alt="" />
            <div className="text-center text-3xl font-semibold text-teal-700">TensorFlow</div>
            {/* <div className="text-lg text-gray-600">
              TensorFlow is a software library for machine learning. It can be used across a range
              of tasks but has a particular focus on training and inference of deep neural networks.
            </div> */}
          </div>
          <div className="mx-auto h-52 max-w-sm items-center space-y-3">
            <img className="mx-auto h-14 w-14" src="/Images/Profile-Icons/react.png" alt="" />
            <div className="text-center text-3xl font-semibold text-teal-700">React</div>
            {/* <div className="text-lg text-gray-600">
              React is a library for building user interfaces based on components. React is used to
              develop single-page, mobile applications.
            </div> */}
          </div>
          <div className="mx-auto h-52 max-w-sm items-center space-y-3">
            <img className="mx-auto h-14 w-14" src="/Images/Profile-Icons/aspenplus.png" alt="" />
            <div className="text-center text-3xl font-semibold text-teal-700">Aspen Plus</div>
            {/* <div className="text-lg text-gray-600">
              Aspen Plus is a chemical process simulator used to mathematically model chemical
              processes, from unit operations to full chemical plants and refineries.
            </div> */}
          </div>
        </div>
      </Section>

      {/* <Section className="bg-gray-50">
        <div className="mb-20 w-full text-4xl font-bold text-slate-900 xs:text-5xl">Contact</div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-6 space-y-4 lg:flex lg:justify-between">
            <div className="flex items-center gap-x-4 xs:gap-x-8">
              <label className="whitespace-nowrap text-xl font-semibold">작성자</label>
              <input
                {...register('writer')}
                className="w-full border-2 px-4 py-2 text-xl focus-visible:outline-none xs:w-64"
                placeholder="작성자"
              />
            </div>
            <div className="flex items-center gap-x-4 xs:gap-x-8 lg:justify-end">
              <label className="whitespace-nowrap text-xl font-semibold">연락처</label>
              <input
                {...register('address')}
                className="w-full border-2 px-4 py-2 text-xl focus-visible:outline-none sm:w-96"
                placeholder="e-mail  or  phone number"
              />
            </div>
          </div>
          <div className="mb-2 text-2xl font-semibold">문의내용</div>
          <TextareaAutosize
            {...register('inquiry')}
            className="w-full resize-none border-2 p-4 text-xl focus-visible:outline-none"
            type="text"
            minRows={8}
            placeholder="내용"
          />

          <div className="ml-auto mt-4 w-fit">
            {isSending ? (
              <Spinner className="fill-teal-500" />
            ) : (
              <button
                type="submit"
                className="text-xl font-semibold text-gray-400 hover:text-black"
              >
                전송
              </button>
            )}
          </div>
        </form>
      </Section> */}
    </>
  );
}

export default Profile;
